export enum RolesUsuario {
  Prestador = "5",
  Funcionario = "3",
  AdministradorCC = "2",
  AdministradorSuper = "1",
  SoloConsulta = "4",
  NoClasicado = "6",
  SoloConsultaNacional = "7",
  Depositario = "8",
}
